
import * as rpc from "@/constants/rpc";
import JdSsr from "@/models/jd-ssr";
import JdReferee from "@/models/jd-referee";
import user from "@/mixins/user";
import {REFEREE_CHAT, REFEREE_CV_SELECT} from "@/constants/bus";
import RefereeUser from "@/models/referee-user";
import {E_FOUND, E_NOT_FOUND} from "@/constants/err";
import {CHAT_CLOSE, CHAT_OPEN_AFTER_ORDER, CHAT_OPEN_AFTER_POST, CHAT_OPEN_ALWAYS} from "@/constants/service";
import {tryToRestore} from "@/utils/store";
import ChatRoom from "@/models/chat-room";
import {toWeibo} from "@/utils/social";
import Jd from "@/models/jd";

export default {
    mixins: [user],
    validate({params}) {
        // 必须是number类型
        return /^\d+$/.test(params.id)
    },
    data() {
        return {
            jd: new JdSsr(),
            owner: new JdReferee(),
            jdReferees: [],

            cvs: [],
            selectCvId: 0,
            selectRefereeUserId: 0,
            cvDrawer: false,

            jdFav: false,

            chatDrawer: false,
            selectedRoom: null,

            recommendJds:[],
        };
    },
    computed: {
        qrCodeUrl() {
            return process.client ? window.location.href : ""
        },
        pageTitle() {
            return this.jd.companyNickName + "急招" + this.jd.title
        },
        pageContent() {
            return this.jd.companyNickName + "高薪招聘" + this.jd.title + ","
            + "薪水范围"+ this.jd.salaryRange + ","
            + "要求有"+this.jd.keyWords + "经验,福利有" + this.jd.welfares + ","
            + "工作地址"+this.jd.provinceName+this.jd.cityName+this.jd.countyName
        },
        hasRecommendJds() {
            return this.recommendJds?.length > 0
        }
    },
    head() {
        return {
            title: this.pageTitle,
            meta: [
                {   hid: 'keywords',
                    name: 'keywords',
                    content: this.jd.keyWords
                },
                {
                    hid: 'description',
                    name: 'description',
                    content: this.pageContent,
                }
            ]
        }
    },
    async asyncData({app, params}) {
        try {
            const p = {_id: parseInt(params.id, 10)}
            const jdRet = await app.$axios.rpcMsg(rpc.CONTENT, rpc.JD_GET_BY_ID, p)
            let owner = null
            const jd = new JdSsr(jdRet.result)
            if (!jd.isNew) {
                const ownerRet = await app.$axios.rpcMsg(rpc.USER, rpc.REFEREE_USER_GET, {_id: jd.userId})
                owner = new RefereeUser(ownerRet.result)
            }
            return {jd, owner}
        } catch (e) {
            console.log(e)
        }
        return {}
    },
    created() {
        try {
            let jdId = parseInt(this.$route.params.id, 10)
            this.getJdReferees(jdId)
            this.checkJdFav(jdId)
            this.getRecommendJds()
        } catch (e) {
            console.log(e)
        }

        this.$bus.$on(REFEREE_CV_SELECT, this.onCvSelect)
        this.$bus.$on(REFEREE_CHAT, this.onChat)
    },
    beforeMount() {
        let state = sessionStorage.getItem('store')
        tryToRestore(this.$store, state)
    },
    beforeDestroy() {
        this.$bus.$off(REFEREE_CV_SELECT)
        this.$bus.$off(REFEREE_CHAT)
    },
    methods: {
        async getJdReferees(jdId) {
            const {result} = await this.$axios.rpcMsg(rpc.CONTENT, rpc.JD_REFEREE_GET_APPROVED, {_id: jdId})
            if (result && result.length > 0) {
                let arr = []
                for (let i = 0; i < result.length; i++) {
                    let referee = new JdReferee(result[i])
                    arr.push(referee)
                }
                this.jdReferees = arr
            }
        },
        async checkCompany() {
            if (!this.hasCompanyId) {
                this.$message.warning("请先去个人页设置您的所属公司，然后才可申请本公司JD的所有权或内推官资格")
                return false
            }

            const p = {_id: this.companyId}
            let ret = await this.$axios.rpcMsg(rpc.USER, rpc.COMPANY_IS_APPROVED, p)
            if (ret && ret.error) {
                return false
            }

            if (ret && !ret.result) {
                this.$message.warning("您所属的公司还没有通过审核")
                return false
            }

            if (this.companyId !== this.jd.companyId) {
                this.$message.warning("您只可以申请本公司JD的所有权或内推官资格")
                return false
            }

            return true
        },
        async checkReferee() {
            if (!this.hasRefereeId) {
                this.$message.warning("您还没有申请所在公司的内推官资格")
                return false
            }

            const p = {_id: this.refereeId}
            let ret = await this.$axios.rpcMsg(rpc.USER, rpc.REFEREE_IS_APPROVED, p)
            if (ret && ret.error) {
                return false
            }

            if (ret && !ret.result) {
                this.$message.warning("您所属公司的内推官资格没有通过审核")
                return false
            }

            return true
        },
        async check() {
            if (!this.isLogin) {
                this.toLogin()
                return false
            }

            if (!await this.checkCompany()) {
                return false
            }

            if (!await this.checkReferee()) {
                return false
            }

            return true
        },
        async applyReferee() {
            if (!await this.check()) {
                return
            }
            const p = {
                jdId: parseInt(this.$route.params.id, 10),
            }
            let {result} = await this.$axios.rpcMsg(rpc.CONTENT, rpc.JD_REFEREE_CREATE, p)
            if (result) {
                this.$message.success("内推官申请已提交给JD发布者，敬请等待审核")
                await this.getJdReferees(p.jdId)
            }
        },
        async applyOwnership() {
            if (!await this.check()) {
                return
            }
            const p = {
                jdId: parseInt(this.$route.params.id, 10)
            }
            let {result} = await this.$axios.rpcMsg(rpc.CONTENT, rpc.JD_OWNERSHIP_CREATE, p)
            if (result) {
                this.$message.success("认领申请已提交给JD发布者，敬请等待审核")
            }
        },
        //Get all CVS
        async getMyCvs() {
            if (!this.isLogin) {
                this.toLogin()
                return
            }

            const ret = await this.$axios.rpcMsg(rpc.CONTENT, rpc.CV_GET_MY)
            if (ret && ret.result) {
                this.cvs = ret.result
                this.cvDrawer = true
            } else {
                this.$message.warning("您还没有填写简历，请先去个人页/我要求职/我的简历中完善简历信息")
            }
        },
        onCvSelect(referee) {
            this.selectRefereeUserId = referee.userId
            this.getMyCvs()
        },
        onChat(referee) {
            if (!this.isLogin) {
                this.toLogin()
                return
            }
            const jdId = parseInt(this.$route.params.id, 10)
            switch(referee.serviceChatType) {
                case CHAT_OPEN_AFTER_POST:
                    this.hasPostByRefereeUserAndJdId(referee,jdId)
                    break
                case CHAT_OPEN_AFTER_ORDER:
                    this.hasPaidOrderByRefereeUserAndJdId(referee,jdId)
                    break
                case CHAT_OPEN_ALWAYS:
                    this.getOrCreateChatRoom(this.user.name+'&'+referee.userName,referee.userId)
                    break
                case CHAT_CLOSE:
                    this.$message.warning("内推官没有开放聊天服务")
                    break
                default:
                    break
            }

        },
        onCloseDrawer() {
            this.cvDrawer = false
        },
        onFav() {
            this.createJdFav(this.jd._id)
        },
        onUnFav() {
            this.deleteJdFav(this.jd._id)
        },
        onComplain() {
            if (!this.isLogin) {
                this.toLogin()
                return
            }
            this.getRandomAdmin()
        },
        onWeibo() {
            toWeibo(window.location.href, this.pageContent+"。热门内推职位，尽在91内推，欢迎大家前来围观:)")
        },
        onCopy() {
            this.$copy(window.location.href)
        },
        async checkJdFav(jdId) {
            if (this.isLogin) {
                const {result, error} = await this.$axios.rpcMsg(rpc.USER, rpc.JD_FAV_CHECK, {_id: jdId}, [E_NOT_FOUND,E_FOUND])
                if (!error) {
                    this.jdFav = result
                    return
                }
            }
            this.jdFav = false
        },
        async createJdFav(jdId) {
            if (!this.isLogin) {
                this.toLogin()
                return
            }
            const ret = await this.$axios.rpcMsg(rpc.USER, rpc.JD_FAV_CREATE, {jdId} )
            if (ret && ret.result) {
                this.jdFav = true
                this.$message.success("您已成功收藏该JD")
            }
        },
        async deleteJdFav(jdId) {
            if (!this.isLogin) {
                this.toLogin()
                return
            }
            const ret = await this.$axios.rpcMsg(rpc.USER, rpc.JD_FAV_DEL, {jdId})
            if (ret && ret.result) {
                this.jdFav = false
                this.$message.success("您已取消收藏该JD")
            }
        },
        async getOrCreateChatRoom(name,toUserId) {
            const p = { name,toUserId }
            const { result } = await this.$axios.rpcMsg(rpc.CHAT, rpc.CHAT_ROOM_GET_OR_CREATE_PRIVATE, p)
            if (result) {
                this.selectedRoom = new ChatRoom(result)
                this.chatDrawer = true
            } else {
                //this.$message.warning("暂时不能聊天，请稍后再试")
            }
        },
        async getRandomAdmin() {
            const { result } = await this.$axios.rpcMsg(rpc.USER, rpc.USER_GET_RANDOM_ADMIN)
            if (result) {
                await this.getOrCreateChatRoom(this.user.name+'&'+result.name,result._id)
            }
        },
        async hasPostByRefereeUserAndJdId(referee,jdId) {
            const p = {
                refereeUserId: referee.refereeUserId,
                jdId,
            }
            const { result } = await this.$axios.rpcMsg(rpc.CONTENT, rpc.POST_HAS_BY_REFEREE_AND_JD_ID,p)
            if (result && result.ok) {
                await this.getOrCreateChatRoom(this.user.name+'&'+referee.userName,referee.refereeUserId)
            } else {
                this.$message.warning("投递简历后可与内推官聊天")
            }
        },
        async hasPaidOrderByRefereeUserAndJdId(referee,jdId) {
            const p = {
                refereeUserId: referee.refereeUserId,
                jdId,
            }
            const { result } = await this.$axios.rpcMsg(rpc.FINANCE, rpc.ORDER_HAS_PAID_BY_REFEREE_AND_JD_ID,p)
            if (result && result.ok) {
                await this.getOrCreateChatRoom(this.user.name+'&'+referee.userName,referee.refereeUserId)
            } else {
                this.$message.warning("购买服务后可与内推官聊天")
            }
        },
        async getRecommendJds() {
            const p = {
                jdId: this.jd._id,
                jdTitle: this.jd.title,
                jobId: this.jd.jobId,
                job: this.jd.job,
                provinceId: this.jd.provinceId,
                cityId: this.jd.cityId,
            }
            const { result } = await this.$axios.rpcMsg(rpc.SEARCH, rpc.SEARCH_RECOMMEND_JDS_FOR_JD, p, [E_NOT_FOUND])
            if (result?.jds?.length > 0) {
                let arr = []
                for (let i = 0; i < result.jds.length; i++) {
                    let jd = new Jd(result.jds[i])
                    arr.push(jd)
                }
                this.recommendJds = arr
            }
        },
    }
}

